import axios, { AxiosResponse } from 'axios';
import { Profile as ProfileModel, Profile } from '../models/profile';
import { Talent } from '../models/talent';

const baseUrl = '/user';
const keycloakRealm =
  'https://dev-ng.allworknow.com/auth/admin/realms/allworknow/';

const changeUserStatus = (payload: {
  id: number;
  activate: boolean;
}): Promise<AxiosResponse<void>> =>
  axios.put<void>(`${baseUrl}/change-status`, payload);

const getAllUsers = (): Promise<AxiosResponse<Talent[]>> =>
  axios.get<Talent[]>(`${baseUrl}/all`);

const updateUserPassword = (password: string): Promise<AxiosResponse<void>> =>
  axios.put<void>(`${baseUrl}/password`, { password });

const loginAsUser = (
  user: string,
  realm: string
): Promise<AxiosResponse<void>> =>
  axios.post<void>(`${keycloakRealm}/users/${user}/impersonation`, {
    user,
    realm
  });

const getProfileData = (): Promise<AxiosResponse<Profile>> =>
  axios.get<Profile>(`${baseUrl}/profile`);

const updateCurrentProfile = (
  payload: ProfileModel
): Promise<AxiosResponse<void>> =>
  axios.put<void>(`${baseUrl}/update-profile`, payload);

const sendCredentials = (payload: number[]): Promise<AxiosResponse<void>> =>
  axios.post<void>(`${baseUrl}/send-credentials`, payload);

export const userService = {
  changeUserStatus,
  getAllUsers,
  updateUserPassword,
  getProfileData,
  sendCredentials,
  loginAsUser,
  updateCurrentProfile
};
